export const AUDIO_CONTEXT_MODES = ['off', 'noise'] as const;
export type AudioContextModesType = typeof AUDIO_CONTEXT_MODES[number];

export interface IAudioContext {
  mode: 'noise'|'off';
  noise?: number;
}
